import GoogleMapReact, { Props } from 'google-map-react'
import React from 'react'

export type MapProps = Omit<Props, 'bootstrapURLKeys'>

const API_KEY = process.env.GATSBY_GOOGLE_MAP_KEY

export const Map = (props: MapProps): JSX.Element => {
    const { children, defaultZoom = 2, defaultCenter = { lat: 10.99835602, lng: 77.01502627 }, ...rest } = props

    return (
        <GoogleMapReact
            bootstrapURLKeys={{ key: API_KEY as string }}
            defaultZoom={defaultZoom}
            defaultCenter={defaultCenter}
            {...rest}
        >
            {children}
        </GoogleMapReact>
    )
}
